// import external dependencies
import "jquery"
import "slick-carousel"
import "bootstrap"

// Import everything from autoload
import "./autoload/_bootstrap.js"; import "./autoload/alphabettical-nav.js"

jQuery(document).ready(() => {
    const DESKTOP_WIDTH = 1260;
    const TABLET_WIDTH = 768;

    $(".nav-link").removeAttr('data-toggle collapse');

    let floatingNav = $('.floating-nav');
    let rRestriction = $('.region-restriction');
    let loadMoreCasino = $('.load-more-casino');
    let footerPromo = $('.footer-promo');
    let slidingNav = $('.sliding-nav'),
        slidingNavSlider = $('.sliding-nav__slider'),
        headers = '';
    if ($('div#primary').hasClass('single-casino')) {
        headers = $('.content-to-navigate h2');
    } else {
        headers = $('.content-to-navigate h2, .content-to-navigate h3');
    }

    window.onload = function () {
        if ($('.sliding-nav__item').length == 0) {
            $('.sliding-nav').remove();
        }

        setActiveSlidingNav();

		if (rRestriction.length) {
            checkRegionRestrictions(rRestriction);
        }

		setProgressBarIndicator();
        setActiveStickyNavLink(floatingNav);
        generateSideNavLinks(floatingNav);
        setMainContentOffset();
        setSlidingNavSticky();
        setProgressBarOffset();
        setFooterPromo();

		if (footerPromo.length) {
            setFooterPromoOpacity(footerPromo);
        }
        fixWdigetTitleColor();
    };
    window.onscroll = function () {
        setProgressBarIndicator();

        setStickyNavPosition(floatingNav);
        setActiveStickyNavLink(floatingNav);

        setMainContentOffset();

        checkScrolledHeader();
        setSlidingNavSticky();
        setProgressBarOffset();

        if (footerPromo.length) {
            setFooterPromoOpacity(footerPromo);
        }
        fixWdigetTitleColor();
    };
    window.onresize = function () {
        setProgressBarIndicator();

        setStickyNavPosition(floatingNav);
        setActiveStickyNavLink(floatingNav);
        setActiveSlidingNav();
        setMainContentOffset();

        setProgressBarOffset();

        if (footerPromo.length) {
            setFooterPromoOpacity(footerPromo);
        }
        fixWdigetTitleColor();
    };
    $(window).scroll(function () {
        setActiveSlidingNav();
    });

    $('.faq__question').on("click", function () {
        $(this).toggleClass('collapsed');
        $(this).next('.faq__answer').toggleClass('collapsed');
    });

    $('.navbar-toggler').on("click", function () {
        $(this).toggleClass('active');
        $('.nav-sidebar, .overlay').toggleClass('active');
        $('body').toggleClass('noscroll');
    });

    $('.submenu-collapse').on("click", function () {
        $(this).parents('li.menu-item-has-children').find('ul').toggleClass('collapse');
        $(this).parents('li.menu-item-has-children').toggleClass('opened');
    });

    $('.header-block').each(function() {
        if ($(this).data('bg') != '' && $(this).data('bg') != undefined) {
            $(this).css('background-image', "url('" + $(this).data('bg') + "')");
        }
    });

    $('.show-shide-user-review').on("click", function () {
        if (!$(this).parent().parent().next().is(':visible')) {
            $(this).parent().parent().parent().addClass('collapsed');
            $(this).parent().parent().next().show();
            $(this).addClass('showing');
        }
        else {
            $(this).parent().parent().parent().removeClass('collapsed');
            $(this).parent().parent().next().hide();
            $(this).removeClass('showing');
        }
    });

    if (window.location.href.indexOf('cryptobet') > -1 && $('.header-block').css('background-image') != '') {
        $('.nav-sidebar').css('background-image', $('.header-block').css('background-image'));
    }

    /**
     * @desc toggle quick facts drop down on casino list item hidden/visible
     */

    $(document).on("click", '.qf-toggle', function () {
        if (window.AS_TABLE == '1') {
            var _this = $(this);
            var _parent = $(this).parent().parent().parent();

            _this.toggleClass('qf-table-item-active');

            if (!_parent.hasClass('hidden')) {
                var is_last = _parent.is(':last-of-type');

                $( $('.casino-list-item__quick-facts[data-id="' + _this.data('id') + '"][data-cid="' + _this.data('cid') + '"]').prop('outerHTML') ).insertAfter( _parent );

                _parent.next().show();
                _parent.addClass('hidden');

                if (!is_last) {
                    _parent.next().addClass('qf-table-mb');

                }
            }
            else {
                _parent.removeClass('hidden');
                if (_parent.next().hasClass('qf-table-mb')) {
                    _parent.next().removeClass('qf-table-mb');
                }
                _parent.next().remove();
            }
        }
        else {
            //check state of current item

            let currentItem = false;
            let wasHidden = false;
            $(this).parents('.casino-list-item').each(function () {
                currentItem = this;
                wasHidden = $(currentItem).hasClass('hidden');
            });

            //update states in list
            $(this).parents('.casino-list').each(function () {
                $(this).find('.casino-list-item').each(function () {
                    if (this === currentItem) {
                        $(this).toggleClass('hidden');
                    } else if (wasHidden) {
                        $(this).addClass('hidden');
                    }
                });
            });
        }
    });

    $(".info-block-content button").on("click", function () {
        var isGuru = window.location.href.indexOf('apostasonline') > -1;
        var lang = {
            more: isGuru ? 'Leia mais' : 'Read more',
            less: isGuru ? 'Leia menos' : 'Read less',
        };

        if ($(this).parent().find(".to-hide").toggleClass('hidden').hasClass('hidden')) {
            $(this).html(lang.more);
            $(this).removeClass('showed');
        } else {
            $(this).html(lang.less);
            $(this).addClass('showed');
        }
    });

    var $infoListSet = $('.info-list-block>.container>.row .item-wrapper');
    function hideTrimItem(infolistItem){
        var isGuru = window.location.href.indexOf('apostasonline') > -1;
        var lang = {
            more: isGuru ? 'Leia mais' : 'Read more',
            less: isGuru ? 'Leia menos' : 'Read less',
        };

        if ($(infolistItem).find(".to-hide").toggleClass('hidden').hasClass('hidden')) {
            $(infolistItem).find('.to-trim').addClass('trimmed');
            $(infolistItem).find('button').html(lang.more);
            $(infolistItem).find('button').removeClass('showed');
        } else {
            $(infolistItem).find('.to-trim').removeClass('trimmed');
            $(infolistItem).find('button').html(lang.less);
            $(infolistItem).find('button').addClass('showed');
        }
    }

    $('.info-list-block>.container>.row').on('click', '.item-wrapper', function (event) {
        if ($(window).width() < DESKTOP_WIDTH) {
            if (event.target.tagName !== 'BUTTON') return;
            hideTrimItem(this);
        } else {

            var numListItem = $infoListSet.index(this);
            if (event.target.tagName !== 'BUTTON') return;

            $('.info-list-block>.container>.row .item-wrapper').each(function (i) {
                if (numListItem <= 2 && i <= 2) {
                    hideTrimItem(this);
                } else if (numListItem > 2 && i > 2) {
                    hideTrimItem(this);
                }
            });
        }


    });



    /**
     * @desc reveal hidden taxonomy links on casino review page on click
     */
    $('.show-more-tax').on("click", function () {
        $(this).parents('.term-tiles, .term-bubbles').each(function () {
            $(this).find('.term-tiles__wrapper, .term-bubbles__wrapper').each(function () {
                $(this).removeClass('hide');
            })
        });
        $(this).parents('.term-tiles__wrapper, .term-bubbles__wrapper').each(function () {
            $(this).hide();
        })
    });

    /**
     * @desc load more casino posts to list on click
     */
    let pageNumber = 1;
    let taxonomy = 0;
    let taxonomyTerm = 0;
    loadMoreCasino.on('click', function () {
        if (window.AS_TABLE == '1') {
            let max_pages = $(this).data('max_pages');
            let current_page = $(this).data('current_page');
            let ppp = $(this).data('ppp');
            let parent = $(this).parent();

            if ((current_page+1) <= max_pages) {
                var n = 0;
                for(var i = 1; i <= ppp; i++) {
                    var items = parent.find('tbody').find('._casino-item');
                    items.each(function() {
                        if ($(this).data('n') == ((current_page * ppp) + i)) {
                            $(this).show();
                            n++;
                        }
                    });
                }

                if (n < ppp) {
                    $(this).hide();
                }

                $(this).data('current_page', (current_page+1));
            }
        }
        else {
            loadMoreCasino.each(function () {
                if (loadMoreCasino.attr('data-term') != undefined){
                    taxonomy = loadMoreCasino.attr('data-taxonomy');
                    taxonomyTerm = loadMoreCasino.attr('data-term');
                }
                pageNumber++;
                let data = {
                    'action': 'load-more-casino',
                    'pageNumber': pageNumber,
                    'taxonomy': taxonomy,
                    'taxonomyTerm': taxonomyTerm,
                };
                $.ajax({
                    url: themeVars.ajaxurl,
                    data: data,
                    type: 'POST',
                    beforeSend: function () {
                        loadMoreCasino.find('span').html('loading...');
                        loadMoreCasino.prop('disabled', true);
                    },
                    success: function (data) {
                        if (data) {
                            loadMoreCasino.find('span').html('show more');
                            loadMoreCasino.prop('disabled', false);
                            loadMoreCasino.before(data);
                        }
                    },
                });
            });
        }
    })

    /**
     * @desc check region restrictions for current client ip on casino review page
     */
    function checkRegionRestrictions(rRestriction) {
        rRestriction.each(function () {
            let data = {
                'action': 'get-region-restrictions',
                'casino_id': rRestriction.data('casino-id'),
            };
            $.ajax({
                url: themeVars.ajaxurl,
                data: data,
                type: 'POST',
                success: function (data) {
                    if (data) {
                        rRestriction.append(data);
                        if (data.search('icon') > -1) {
                            $('.region-restriction-preloader').remove();
                            rRestriction.addClass('active');
                        }
                    }
                },
            });
        })
    }

    /**
     * @desc make fixed header transparent if windowed scrolled for more than 50px
     */
    function checkScrolledHeader() {
        if (Math.max(window.scrollY, window.pageYOffset) > 50) {
            $('header').addClass('scrolled');
        } else {
            $('header').removeClass('scrolled');
        }
    }

    /**
     * @desc show footer promo block on pages with predefined class
     */
    function setFooterPromo() {
        $('.show-footer-promo').each(
            function () {
                $('.footer-promo').addClass('active');
            }
        )
    }

    //Sliding sticky header navigation-->
    slidingNavSlider.on("init", function () {
        setTimeout(function () {
            let slickSlideIndex = 0;
            if (headers.length) {
                slidingNav.addClass('active');
                headers.each(function () {
                    let iconImg = '',
                        boxTitle = $(this).data('nav-heading'),
                        boxContainer = $(this),
                        boxLink = boxContainer.attr('id');
                    if (!boxTitle) {
                        boxTitle = $(this).text()
                    }
                    if (!boxLink) {
                        boxContainer = $(this).parent().parent().parent();
                        boxLink = boxContainer.attr('id');
                    }
                    if (!boxLink) {
                        boxContainer = $(this).parents('.rating-box');
                        boxLink = boxContainer.attr('id');
                        iconImg = boxContainer.find('.rating-box-header__icon').html();
                    }

                    if (boxLink) {
                        let slide = '<a class="sliding-nav__item" href="#' + boxLink + '">' + iconImg + '<span>' + boxTitle + '</span>' + '</a>';
                        slidingNavSlider.slick('slickAdd', slide);
                        $(this).attr('data-slick-slide-item', slickSlideIndex);
                        slickSlideIndex++;
                    }
                });
            }
        }, 0);
    });

    function setActiveSlidingNav() {
        let scrollPosition = window.scrollY,
            fixedOffset = 0,
            pBarHeight = $('#progress-bar').outerHeight(),
            sNavHeight = $('.sliding-nav').outerHeight(),
            headerHeight = $('header').outerHeight(),
            activeSlide = slidingNavSlider.slick('slickCurrentSlide');
        fixedOffset = pBarHeight + sNavHeight + headerHeight;

        //check visible headers from bottom to top
        $(headers.get().reverse()).each(function () {
            let hIndex = ($(this).data('slick-slide-item'));
            let hPosition = 0;
            let anchorId = '';
            anchorId = $(this).attr('id');
            if (!anchorId) {
                $(this).parents('.rating-box').each(function () {
                    anchorId = $(this).attr('id');
                    hPosition = $(this).offset().top;
                });
            } else {
                hPosition = $(this).offset().top;
            }
            if (anchorId) {
                if ((scrollPosition - hPosition + fixedOffset) >= -1) {
                    if (activeSlide !== hIndex) {
                        slidingNavSlider.slick("slickGoTo", hIndex);
                    }
                    return false;
                }
            }
        });
    }

    function setSlidingNavSticky() {
        let navContainer = slidingNav.parent();
        let containerPosition = 0;
        if (navContainer.length) {
            containerPosition = navContainer.offset().top;
        }
        let scrollPosition = window.scrollY;
        let headerHeight = $('header').outerHeight();
        if ((containerPosition - scrollPosition - headerHeight) < 0) {
            $(slidingNav).addClass('stickon');
        } else {
            $(slidingNav).removeClass('stickon');
        }
    }

    slidingNavSlider.slick({
        infinite: false,
        variableWidth: true,
        slidesToScroll: 1,
        focusOnSelect: false,
        arrows: false,
        swipeToSlide: true,
    });
    //<--Sliding sticky header navigation

    /**
     * @desc activate mobile app block slider on casino review page
     */
    $('.look-and-feel-slider').slick({
        slidesToScroll: 1,
        slidesToShow: 1,
        infinite: false,
        mobileFirst: true,
        dots: true,
        nextArrow: '.next',
        prevArrow: '.prev',
        appendDots: '.look-and-feel-slider__controls .dots',
    });

	var sliders = $('.news-slider, .games-list-popular, .cryptocurrency-list-popular, .esports-list-popular');
	var progressBarSlider = $('.slider-progress');
	var progressBarLabel = $( '.slider__label' );

	sliders.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
		var calc = ( (nextSlide) / (slick.slideCount - 1) ) * 100;
		var wWidth = $(window).width();
		if (wWidth >= DESKTOP_WIDTH) {
			calc = ( (nextSlide) / (slick.slideCount - 3) ) * 100;
		} else {
			if (wWidth >= TABLET_WIDTH) {
				calc = ( (nextSlide) / (slick.slideCount - 2) ) * 100;
			}
		}
		progressBarSlider
		.css('background-size', calc + '% 100%')
		.attr('aria-valuenow', calc );

		progressBarLabel.text( calc + '% completed' );
	});

    /**
     * @desc activate news slider
     */
    $('.news-slider, .games-list-popular, .cryptocurrency-list-popular, .esports-list-popular').slick({
        slidesToScroll: 1,
        infinite: false,
        mobileFirst: true,
        dots: false,
        nextArrow: '.next',
        prevArrow: '.prev',
        responsive: [
            {
                breakpoint: 1260,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 0,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    });

    /**
     * @desc init and control user reviews casino rating picker
     */
    if (typeof $("#round-slider").roundSlider === "function") {
        $("#round-slider").roundSlider({
            circleShape: 'full',
            radius: 80,
            sliderType: "min-range",
            width: "8",
            value: 0,
            max: "5",
            mouseScrollAction: true,
            lineCap: "round",
            handleShape: "dot",
            handleSize: "+20",
            startAngle: 90,
            editableTooltip: false,
            tooltipFormat: function (args) {
                for (let step = 0; step <= 5; step++) $(args.control).removeClass('color-' + step);
                $(args.control).addClass('color-' + args.value);

                $('.acf-comment-fields .acf-field[data-name="rating"] input').val(args.value);

                if (args.value) {
                    return args.value + ',0';
                } else {
                    return 'N/A';
                }
            },
            change: function (args) {
                $(args.control).addClass('color-' + args.value);
                $(args.control).removeClass('color-' + args.preValue);
                $('.acf-comment-fields .acf-field[data-name="rating"] input').val(args.value);
            },
            create: function () {
                this.control.find(".rs-tooltip-text").css({
                    "font-family": "Gilroy, sans-serif",
                    "font-size": "3rem",
                    "font-weight": "bold",
                    "line-height": "3.625rem",
                    "letter-spacing": "-2px",
                });
                this._updateTooltipPos();	// refresh the tooltip position
                $('.acf-comment-fields .acf-field[data-name="rating"] input').val(0);
            },
        });
    }

    /**
     * @desc set footer promo opacity depending on scroll position
     */
    function setFooterPromoOpacity(footerPromo) {
        let footerPosition = $('#footer-container').offset().top;
        let footerPromoBottom = footerPromo.offset().top + footerPromo.outerHeight(),
            pBarHeight = $('#progress-bar').outerHeight(),
            sNavHeight = $('.sliding-nav').outerHeight(),
            headerHeight = $('header').outerHeight();
        if (((footerPosition - footerPromoBottom) <= 0) || ((pBarHeight + sNavHeight + headerHeight) >= window.scrollY)) {
            footerPromo.addClass('hidden');
        } else {
            footerPromo.removeClass('hidden');
        }
    }

    /**
     * @desc set progress bar indicator on scroll
     */
    function setProgressBarIndicator() {
        var map = {
            'apostasonline': '#1BC153',
            'casinosblockchain': '#3E47E0',
            'solanacasinos': '#681FE0',
            'tethercasinos': '#028888',
            'cryptobet': '#1573FF',
            'crashgambler': '#0F7861',
            'plinkogambler': '#4154FF',
        };

        let color = '';
        for(var k in map) {
            if (window.location.href.indexOf(k) > -1) {
                color = map[k];
            }
        }

        let winScroll = document.body.scrollTop || document.documentElement.scrollTop,
            height = document.documentElement.scrollHeight - document.documentElement.clientHeight,
            scrolled = (winScroll / height) * 100;
        $('#progress-bar').css('background', 'linear-gradient(to right, ' + color + ' 0%, ' + color + ' ' + scrolled + '%, #dddeea ' + scrolled + '%, #dddeea 100%)');
    }

    /**
     * @desc set window scroll progress bar top offset
     */
    function setProgressBarOffset() {
        let pBar = $('#progress-bar.sticky'),
            sNav = $('.sliding-nav.active'),
            sNavHeight = sNav.length ? sNav.outerHeight() : 0,
            header = $('header'),
            wWidth = $(window).width(),
            topOffset = 0;
        if (wWidth < DESKTOP_WIDTH) {
			topOffset = header.outerHeight() + sNavHeight;
        }
        if (parseInt(pBar.css('top'), 10) !== topOffset) {
            pBar.css('top', topOffset);
        }
    }

    /**
     * @desc fix widget title color for dark background
     */
    function fixWdigetTitleColor() {
        let widgetTitle = $('.widget-title'),
            headerBgBlock = $('.news-single-header-bg');
        if ($('.news-single-header-bg').length)         // use this if you are using id to check
        {
            // it exists
            if (widgetTitle.length && headerBgBlock) {
                if ((headerBgBlock.offset().top + headerBgBlock.outerHeight() - widgetTitle.offset().top) >= 0) {
                    widgetTitle.css('color', 'white');
                } else {
                    widgetTitle.css('color', 'initial');
                }
            }
        }
    }

    // Floating side header navigation (desktop only) -->
    function setStickyNavPosition(floatingNav) {
        let navContainer = floatingNav.parents('.container'),
            navContainerTop = $('.floating-nav-top'),
            navContainerBottom = floatingNav.parents('.floating-nav-bottom'),
            containerPosition = navContainerTop.length ? navContainerTop.offset().top : 0,
            containerWidth = navContainer.outerWidth(),
            windowWidth = $(window).width(),
            scrollPosition = window.scrollY;

        let direction = (window.location.href.indexOf('casinosblockchain') > -1 || window.location.href.indexOf('tethercasinos') > -1 || window.location.href.indexOf('cryptobet') > -1 || window.location.href.indexOf('crashgambler') > -1 || window.location.href.indexOf('plinkogambler') > -1) ? 'right' : 'left';
        let offset = ((window.location.href.indexOf('plinkogambler') > -1 || window.location.href.indexOf('crashgambler') > -1 || window.location.href.indexOf('cryptobet') > -1) && (window.is_post)) ? 124 : 24;
        let offset2 = ((window.location.href.indexOf('plinkogambler') > -1 || window.location.href.indexOf('crashgambler') > -1 || window.location.href.indexOf('cryptobet') > -1) && (window.is_post)) ? 214 : 0;
        //let newsBlock = $('.benefits-block__news');
        //let footer = $('footer');

        //check if we have bottom container
        if (navContainerBottom.length && screen.width > 1000) {
            let navContainerBottomPosition = navContainerBottom.offset().top + navContainerBottom.height();
            let navContainerBottomOffset = window.scrollY + window.innerHeight - navContainerBottomPosition;
            if (((navContainerBottomPosition - window.scrollY - window.innerHeight) <= -300 ) && (navContainerBottomOffset >= 0)) {
                if (window.location.href.indexOf('casinosblockchain') > -1) {
                    floatingNav.fadeOut(150);
                }
            } else if ((scrollPosition - containerPosition + offset) >= offset2) {
				//check if scrolled past top container
                floatingNav.fadeIn(300);
                floatingNav.addClass('stickon');
                floatingNav.removeClass('sticktop');
                let positionRight = (windowWidth - containerWidth) / 2 + 'px';
                let cssObj = {};
                cssObj[direction] = positionRight;

                floatingNav.css(cssObj);
                floatingNav.css({'top': '24px'});
            } else {
                //leave element as it is
                floatingNav.fadeIn(300);
                floatingNav.removeClass('stickon');
                floatingNav.removeClass('sticktop');

                let cssObj = {};

                if (window.location.href.indexOf('plinkogambler') > -1 || window.location.href.indexOf('crashgambler') > -1 || window.location.href.indexOf('cryptobet') > -1) {
                    if (window.is_post) {
                        cssObj.top = '124px';
                    }
                    else {
                        cssObj.top = '24px';
                    }
                }

                cssObj[direction] = 0;
                floatingNav.css(cssObj);
            }
        } else {
            //the same but for case when we don't have bottom container
            if ((scrollPosition - containerPosition + 24) >= 0) {
                floatingNav.addClass('stickon');
                let positionRight = (windowWidth - containerWidth) / 2 + 'px';

                let cssObj = {};
                cssObj[direction] = positionRight;
                floatingNav.css(cssObj);
            } else {
                if (window.location.href.indexOf('cryptobet') > -1 || window.location.href.indexOf('crashgambler') > -1 || window.location.href.indexOf('plinkogambler') > -1) {
                    let positionRight = '0px';
                    let cssObj = {};
                    cssObj[direction] = positionRight;
                    floatingNav.css(cssObj);
                }

                floatingNav.removeClass('stickon');
            }
        }
    }

    function generateSideNavLinks(floatingNav) {
        let headers = '',
            generatedNav = floatingNav.find('.generated-nav');
        if ($('div#primary').hasClass('single-casino')) {
            headers = $('.content-to-navigate h2');
        } else {
            headers = $('.content-to-navigate h2, .content-to-navigate h3');
        }
        if (headers.length) {
            headers.each(
                function () {
                    let boxTitle = $(this).data('nav-heading'),
                        boxLink = $(this).attr('id');
                    if (!boxTitle) {
                        boxTitle = $(this).text()
                    }
                    if (!boxLink) {
                        boxLink = $(this).parents('.rating-box').attr('id');
                    }
                    let iconImg = $(this).parent().parent().find('.rating-box-header__icon').html();
                    if (!iconImg) {
                        iconImg = '';
                    }
                    if (boxLink) {
                        generatedNav.append('<li ' + ($(this).prop('tagName') === 'H3' ? 'class="pl-4"' : '') + ' data-link="' + boxLink + '"><a href="#' + boxLink + '">' + iconImg + boxTitle + '</a></li>');
                    }
                }
            )
        }
        if (!generatedNav.html()) {
            generatedNav.hide();
        }
    }

    function setActiveStickyNavLink(floatingNav) {
        let casinoNavigation = floatingNav.find('.generated-nav').find('li'),
            casinoNavigationN = casinoNavigation.length,
            scrollPosition = window.scrollY;
        if (casinoNavigationN) {
            let hasActive = 0;
            for (let i = 0; i < casinoNavigationN; i++) {
                let boxToCheck = $('#' + casinoNavigation.eq(i).data('link'));
                let boxPosition = boxToCheck.offset().top;
                if ((scrollPosition - boxPosition) >= -300) {
                    hasActive = 1;
                    casinoNavigation.eq(i).addClass('active');
                    if (i) {
                        casinoNavigation.eq(i - 1).removeClass('active');
                    }
                } else {
                    casinoNavigation.eq(i).removeClass('active');
                }
            }
            if (!hasActive) {
                casinoNavigation.eq(0).addClass('active');
            }
        }
    }

    /**
     * @desc Reveal hidden casino links on Taxonomy archive page
     */
    $('.taxonomy-casino').each(function () {
        let length = $(this).children().length;
        if (length > 4) {
            $(this).children('div:gt(3)').addClass('child-hide');
            $(this).append('<button class="taxonomy-casino__button"> +' + ( length - 4 ) + ' </button>');
        }
    });

    $(".taxonomy-casino__button").on("click", function () {
        if ($(this).hasClass('show')) {
            $(this).removeClass('show');
            $(this).parent().children('div:gt(3)').addClass('child-hide');
            $(this).text('+' + ( $(this).parent().children('div').length - 4 ) );
        } else {
            $(this).parent().children('div:gt(3)').removeClass('child-hide');
            $(this).text("<");
            $(this).addClass('show');
        }
    });

    /**
     * @desc Set main content offset to compensate fixed header height
     */
    // function setMainContentOffset() {
    //     let blockToSet = $('.top-content-offset'),
    //         pBarHeight = $('#progress-bar').outerHeight(),
    //         sNavHeight = $('.sliding-nav.active.stickon').outerHeight(),
    //         topOffSet = pBarHeight + sNavHeight + 4,
    //         wWidth = $(window).width();
    //     let offset = window.location.href.indexOf('cryptobet') || window.location.href.indexOf('crashgambler') || window.location.href.indexOf('plinkogambler') > -1 ? 28 : 0;

    //     if ((wWidth < DESKTOP_WIDTH) && (sNavHeight)) {
    //         if (parseInt(blockToSet.css('margin-top'), 10) !== topOffSet) {
	// 			blockToSet.css('margin-top', topOffSet - offset);
    //         }
    //     } else {
    //         blockToSet.css('margin-top', 'unset');
    //     }
    // }

    /**
     * @desc Set main content offset to compensate fixed header height
     */
    function setMainContentOffset() {
        let blockToSet = $('.top-content-offset'),
            pBarHeight = $('#progress-bar').outerHeight(),
            sNavHeight = $('.sliding-nav.active.stickon').outerHeight(),
            topOffSet = pBarHeight + sNavHeight + 4,
			wWidth = $(window).width();
		const sites = ['cryptobet', 'crashgambler', 'plinkogambler'];
		let offset = sites.some(keyword => window.location.href.includes(keyword)) ? 28 : 0;
        if ((wWidth < DESKTOP_WIDTH) && (sNavHeight)) {
            if (parseInt(blockToSet.css('margin-top'), 10) !== topOffSet) {
                blockToSet.css('margin-top', (topOffSet - offset));
            }
        } else {
            blockToSet.css('margin-top', 'unset');
        }
    }


    /**
     * @desc Compensate fixed header for anchor scroll
     */
    (function (document, history, location) {
        let HISTORY_SUPPORT = !!(history && history.pushState);
        let anchorScrolls = {
            ANCHOR_REGEX: /^#[^ ]+$/,

            init: function () {
                this.scrollToCurrent();
                $(window).on('hashchange', $.proxy(this, 'scrollToCurrent'));
                $('body').on('click', 'a.sliding-nav__item', $.proxy(this, 'delegateAnchors'));
            },

            getFixedOffset: function () {
                if ($(window).width() < DESKTOP_WIDTH) {
                    let pBarHeight = $('#progress-bar').outerHeight(),
                        sNavHeight = $('.sliding-nav').outerHeight(),
                        headerHeight = $('header').outerHeight();
                    return pBarHeight + sNavHeight + headerHeight;
                } else {
                    return 0;
                }
            },

            scrollIfAnchor: function (href, pushToHistory) {
                let match, anchorOffset;

                if (!this.ANCHOR_REGEX.test(href)) {
                    return false;
                }

                match = document.getElementById(href.slice(1));

                if (match) {
                    anchorOffset = $(match).offset().top - this.getFixedOffset();
                    $('html, body').animate({scrollTop: anchorOffset});
                    if (HISTORY_SUPPORT && pushToHistory) {
                        history.pushState({}, document.title, location.pathname + href);
                    }
                }

                return !!match;
            },

            scrollToCurrent: function (e) {
                if (this.scrollIfAnchor(window.location.hash) && e) {
                    e.preventDefault();
                }
            },

            delegateAnchors: function (e) {
                let elem = e.currentTarget;

                if (this.scrollIfAnchor(elem.getAttribute('href'), true)) {
                    e.preventDefault();
                }
            },
        };
        $(document).ready($.proxy(anchorScrolls, 'init'));
    })(window.document, window.history, window.location);



});

// Iframe for Game Embedded Articles
const firesIframe = $('.firesIframe');
firesIframe.on('click', function () {
	let iframeURL = $(this).attr('data-url');
	let id = $(this).attr('data-identificador');
	$('#iframe-game-' + id).attr('src', iframeURL);
	$('#iframe-game-' + id).attr('width', '100%');
	$('#embedded-game-wrapper-item-' + id).remove();
	$('#iframe-game-' + id).removeClass('d-none');
	$('#iframe-footer-' + id).removeClass('d-none');
	$('.footer-promo').removeClass('active');
	let wrapper = $('#wrapper-' + id);
	let bottomSpace = wrapper.outerHeight();
	$('#iframe-footer-' + id).css('bottom', -bottomSpace);
	let embeddedIframe = $('#embedded-game-iframe-' + id);
	if (embeddedIframe.length) {
		embeddedIframe.css('margin-bottom', 20 + bottomSpace);
		var viewportHeight = $(window).height();
		var elementHeight = $('#embedded-game-wrapper-' + id).outerHeight();
		var offset = (viewportHeight - elementHeight) / 2;

		$('html, body').animate({
			scrollTop: embeddedIframe.offset().top - offset,
		}, 2000);
	}
});

/**
 * @desc Games Recommendation init
 */
function initGamesRecommendation() {
	$('.games-recommendation__slider').slick({
		infinite: false,
		swipeToSlide: true,
		mobileFirst: true,
		touchThreshold: 200,
		speed: 200,
		useTransform: false,
		slidesToShow: 2,
		slidesToScroll: 2,
		arrows: false,
		dots: false,
		variableWidth: true,
		responsive: [
			{
				breakpoint: 390,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 4,
				},
			},
		],
	});
}

initGamesRecommendation();

/*document.addEventListener('touchstart', function(e){
    e.preventDefault();
}, { passive: true });
*/



// WEBPACK FOOTER //
// ./scripts/main.js